const recurse = (n, arr, results = []) => {
  const { min, max, rate, blendedRange } = arr[0]
  const tierRange = max - min
  const amount = n > tierRange ? tierRange : n

  const tierBalance = amount >= tierRange ? tierRange : amount

  const obj = {
    amount: Math.round(amount),
    interest: amount * (rate / 100),
    rate,
    blendedRange,
    dividend:
      amount < 1
        ? amount
        : (Math.pow(1 + rate / 100 / 12, 12) - 1) * tierBalance,
  }

  const newResults = [...results, obj]
  return arr.length > 1
    ? recurse(n - amount, arr.slice(1), newResults)
    : newResults
}

export const calculate = (deposit, rateSheet) => {
  const results = recurse(Number(deposit), rateSheet)

  const dividends = results
    .map(a => a.dividend)
    .reduce((a, b) => a + b)
    .toFixed(2)

  const blendedAPY = ((dividends / deposit) * 100).toFixed(2)

  const firstYrInterest = results
    .map(a => a.interest)
    .reduce((a, b) => a + b)
    .toFixed(2)

  const res = {
    tiers: results,
    blendedAPY,
    firstYrInterest,
    deposit,
    dividends,
  }

  return res
}



// WEBPACK FOOTER //
// ./src/calculate.js